import { useContext } from "react";
import { type LocalSettings, LocalSettingsContext } from "src/contexts/LocalSettingsContext";
import type { SettingsContextValue } from "src/contexts/SettingsContext";

export const useSettings = (): SettingsContextValue<LocalSettings> =>
    useContext(LocalSettingsContext);

export default useSettings;
